import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Kontakt from "@/pages/Kontakt";
import Impressum from "@/pages/Impressum";
import ResetPassword from "@/pages/ResetPassword";
import { GuideArticle, GuideOverview } from "@/pages/Ratgeber";
import SmoothScroll from "@/components/site/SmoothScroll";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // On route change, jump to top (Lenis handles smooth in-page navigation)
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-[#0F172A] text-white">
      <SmoothScroll>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/ratgeber" element={<GuideOverview />} />
            <Route path="/ratgeber/:id" element={<GuideArticle />} />
          </Routes>
        </BrowserRouter>
      </SmoothScroll>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1E293B",
            color: "#fff",
            border: "1px solid rgba(0,250,248,0.15)",
            borderRadius: "16px",
          },
        }}
      />
    </div>
  );
}

export default App;
